import React, { ChangeEvent, FC } from 'react';
import { Field, FieldProps, useFormikContext } from 'formik';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import { ContentInput } from 'api';

const useStyles = makeStyles(theme => ({
  body: {
    marginBottom: theme.spacing(2),
  },
}));

const BodyTextField: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext<ContentInput>();

  function onChange(event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
    setFieldValue(`content_object.body`, event.target.value);
  }

  return (
    <Field name="content_object.body">
      {({ field }: FieldProps<'content_object.body'>) => (
        <TextField
          fullWidth
          value={field.value}
          variant="outlined"
          multiline
          rows="8"
          placeholder={t('posting:addTextHere')}
          className={classes.body}
          onChange={onChange}
        />
      )}
    </Field>
  );
};

export default BodyTextField;
